import { type InsuranceCorporateIdentity } from "../types";

export function BKKPfalzLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M37.6213 255.392C37.6213 223.487 63.5264 197.625 95.4832 197.625C127.44 197.625 153.345 223.487 153.345 255.392C153.345 287.297 127.44 313.159 95.4832 313.159C63.5264 313.159 37.6213 287.297 37.6213 255.392Z"
        fill="#0071BC"
      />
      <path
        d="M105.386 255.392C105.386 223.487 131.291 197.625 163.248 197.625C182.436 197.625 199.442 206.951 209.97 221.309H172.043C161.957 221.309 153.782 229.47 153.782 239.539V272.465C153.782 282.534 161.957 290.695 172.043 290.695H209.049C198.465 304.36 181.886 313.159 163.248 313.159C131.291 313.159 105.386 287.297 105.386 255.392Z"
        fill="#FFCB04"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.693 281.638H190.256C194.856 281.638 200.017 281.638 204.051 279.518C209.637 276.554 211.125 271.892 211.125 267.938C211.125 257.486 201.999 255.86 198.818 255.297V255.157C201.364 254.519 209.709 252.615 209.709 243.573C209.709 239.055 207.445 236.301 205.82 234.819C201.151 230.652 194.571 230.652 188.136 230.652H167.693V281.638ZM181.416 239.903H189.125C190.61 239.903 192.166 239.903 193.723 241.103C195.138 242.232 195.705 244.07 195.705 245.621C195.705 247.813 194.643 249.648 193.015 250.567C191.812 251.202 190.328 251.202 188.064 251.202H181.416V239.903ZM181.484 260.24H188.913C190.823 260.24 196.622 260.24 196.622 266.384C196.622 272.315 190.964 272.315 189.339 272.315H181.484V260.24Z"
        fill="#0071BC"
      />
      <path
        d="M212.532 281.137H226.608V254.555L243.25 281.137H260.446L241.792 253.168L259.06 231.155H242.624L226.608 253.099V231.155H212.532V281.137Z"
        fill="#0071BC"
      />
      <path
        d="M261.333 281.137H275.409V254.555L292.051 281.137H309.246L290.594 253.168L307.862 231.155H291.426L275.409 253.099V231.155H261.333V281.137Z"
        fill="#0071BC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M323.65 281.137H337.59V263.138L342.308 263.07C345.011 263.07 351.043 263.07 354.925 260.921C356.87 259.883 362.484 256.076 362.484 247.286C362.484 240.776 359.643 236.278 355.415 233.717C351.32 231.155 346.259 231.155 342.376 231.155H323.65V281.137ZM337.59 240.432H341.543C345.564 240.432 348.34 240.776 348.34 246.87C348.34 253.586 345.011 253.586 341.614 253.586H337.59V240.432Z"
        fill="#0071BC"
      />
      <path
        d="M388.656 231.292C387.201 231.224 384.496 230.946 380.959 230.946C367.3 230.946 367.161 238.214 367.368 246.523H363.656V254.967H367.161V281.137H379.919V254.967H388.31V246.523H379.919C379.848 243.615 379.712 239.323 385.049 239.323C386.781 239.323 388.103 239.598 388.656 239.739V231.292Z"
        fill="#0071BC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M424.046 281.137C423.422 277.676 423.351 276.982 423.351 274.493V258.29C423.351 254.554 422.518 251.299 420.3 249.153C416.627 245.552 409.969 245.136 406.85 245.136C400.538 245.136 395.128 246.729 392.425 249.5C389.791 252.199 389.791 255.176 389.722 256.769H402.202C402.134 252.824 404.42 251.509 406.85 251.509C410.8 251.509 411.285 254.967 411.217 258.705C396.239 258.084 387.431 261.545 387.431 271.029C387.431 277.192 391.177 281.827 399.707 281.827C406.85 281.827 409.553 278.507 411.149 276.151C411.149 278.369 411.285 279.89 411.563 281.137H424.046ZM411.149 264.728C411.217 266.184 411.217 269.023 410.179 271.238C408.861 274.005 406.433 274.561 405.044 274.561C401.925 274.561 400.26 272.412 400.26 269.854C400.26 264.869 405.6 264.8 411.149 264.728Z"
        fill="#0071BC"
      />
      <path
        d="M426.374 281.135H439.409V231.153H426.374V281.135Z"
        fill="#0071BC"
      />
      <path
        d="M441.753 281.137H474.136V272.9H456.385L473.303 254.97V246.386H442.515V254.76H458.463L441.753 272.344V281.137Z"
        fill="#0071BC"
      />
    </svg>
  );
}

export const BKKPfalz: InsuranceCorporateIdentity = {
  id: "bkk-pfalz",
  name: "BKK Pfalz",
  logo: BKKPfalzLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "bkk pfalz",
  type: "statutory",
};
